// extracted by mini-css-extract-plugin
module.exports = {"expenseDescription":"style_expenseDescription__2iOLr","hidden":"style_hidden__2vS5b"};